// extracted by mini-css-extract-plugin
export var dataCell = "_lw-2";
export var dataRow = "_lw-0";
export var headerRow = "_lw-1";